// extracted by extract-css-chunks-webpack-plugin
module.exports = {"placeholder":"placeholder-1j7Ge","image":"image-1ll21","pulse":"pulse-1cY8O","line":"line-2cZeu"};